import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';
import {ItemRouteModule} from '../../item/item.route';
import {PaymentModule} from '.././payment/payment.module';
import {SharedModule} from '../../../shared/shared.module';
import {SdkApplepayService} from '../../../core/services/sdk-applepay-service';
import {SdkNativeOepayService} from '../../../core/services/sdk-native-oepay-service';
import {SdkAlipayHKService} from '../../../core/services/sdk-alipay-hk-service';
import {DiscountManager} from 'aigens-ng-core';
import {SdkWeChatPayService} from '../../../core/services/sdk-wechat-pay-service';
import { ComboModifier } from '../../item/combo-modifier.module';
import { CartScrollPage } from './cart-scroll-page';
import {DialogsModule} from '../../../dialogs/dialogs.module';
import { MemberRouteModule } from '../../member/member.route';
import { MemberCourtRouteModule } from '../../member/member-court/member-court.route';
@NgModule({
    declarations: [CartScrollPage],
    exports: [],
    entryComponents: [],
    imports: [
        SharedModule,
        ItemRouteModule,
        PaymentModule,
        DialogsModule,
        ComboModifier,
        MemberRouteModule,
        MemberCourtRouteModule,
        RouterModule.forChild([
            {
                path: '',
                component: CartScrollPage
            },
            {
                path: 'qr-code',
                loadChildren: 'src/app/pages/qr-code/qr-code.module#QrCodeModule'
            }
        ])
    ],
    providers: [SdkApplepayService, SdkNativeOepayService, SdkAlipayHKService, SdkWeChatPayService, DiscountManager]
})
export class CartScrollModule {
}
